import { render, staticRenderFns } from "./album.vue?vue&type=template&id=72aa6419"
import script from "./album.vue?vue&type=script&lang=ts"
export * from "./album.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports